import type { FC, ReactNode } from 'react';

import { Button } from '@packages/shared/src/ui/Button/Button';

export type FilterSettingsMobileButtonProps = {
  children: ReactNode;
  onClick?: () => void;
};

export const FilterSettingsMobileButton: FC<FilterSettingsMobileButtonProps> = ({
  children,
  onClick,
}) => (
  <Button className="flex h-[2.75rem] pr-1 sm:h-[2.25rem]" onClick={onClick}>
    <div className="mr-auto w-full overflow-hidden text-left leading-normal hyphens-auto">
      {children}
    </div>
    <span className="icon-emp-arrow-medium-down size-4" />
  </Button>
);
